import { Button, Card } from "../primitives";
import { useTranslation } from "../../hooks/useTranslation";
import { useState } from "react";
export default function CancelSubscription({ onConfirm, onCancel }) {

    const t = useTranslation();
    const [loading, setLoading] = useState(false);

    async function handleCancelSubscription() {
        setLoading(true);
        await onConfirm();
        setLoading(false);
    }

    return (
        <Card className='white'>
            <Card.Header>
                <h2>{t('Cancel Subscription')}</h2>
            </Card.Header>
            <Card.Body>
                <p>{t('Are you sure you want to cancel your subscription?')}</p>
                <Button onClick={handleCancelSubscription} loading={loading} className='submit settings'>{t('Cancel Subscription')}</Button>
                <Button onClick={onCancel} disabled={loading} className='settings'>{t('Cancel')}</Button>
            </Card.Body>
        </Card>
    )
}
